<button
  class="flex items-center justify-between gap-3 cursor-pointer select-none"
  (click)="toggleSelection($event)"
  (keydown)="toggleSelection($event)"
>
  <ng-content></ng-content>

  <div [class]="class()">
    <span
      class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"
    ></span>
    <input
      type="checkbox"
      class="absolute cursor-pointer inset-0 size-full appearance-none focus:outline-hidden"
      [checked]="checked()"
    />
  </div>
</button>
